module.exports = __webpack_public_path__ + "static/media/gaming-zone.986fad6a.svg";